export default __webpack_public_path__ + "static/media/Search_expert_blue.14591b27.svg";